import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/carrier-boxes.js';
import form from '../forms/carrier-boxes.js';
import * as types from '../types.js';

const carrier_boxes = function()
{
	let carrier_boxes_crud = crud.create({
		addFilter(params) {
			crud.addFilter.call(this, params);
			if (this.filter && JSON.stringify(this.filter).includes('is_disabled'))
				params.append('include_disabled', '1');
		},
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_carriers, this.queryAll()).then((data) => data && db.set('carriers', data).catch(() => {}));
		},
		async queryData(query)
		{
			return await api.call(api.list_carrier_boxes, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_carrier_box, ...JSON.parse(id));
		},
		async setDisabled(disabled) {
			const ids = await this.getSelectedIds(['company_id', 'id']);
			if (!ids.length)
				return notify('Selecione ao menos uma caixa.', 'Caixas');
			const action = disabled ? 'Inativar' : 'Ativar';
			ask(`Confirma ${action} ${ids.length} caixa(s)?`, action, async (answer) => {
				if (answer !== 'Y')
					return;
				for (const [company_id, id] of ids) {
					const resp = await api.call(api.patch_carrier_box, company_id, id, { is_disabled: !!disabled });
					if (resp == null) {
						notify('Falha ao atualizar a caixa.', 'Caixas');
						return;
					}
				}
				this.loadPage();
			});
		},
		async saveRecord(data, old_data)
		{
			const record = {
				carrier_id: Number(data.carrier_id),
				code: data.code,
				length_cm: data.length_cm,
				width_cm: data.width_cm,
				depth_cm: data.depth_cm,
				max_weight_kg: data.max_weight_kg,
				is_disabled: data.is_disabled == '1',
			};
			if (old_data)
				return await api.call(api.update_carrier_box, data.company_id, data.id, record);
			return await api.call(api.insert_carrier_box, data.company_id, record);
		},
	});

	const fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Caixa', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da caixa' },
		{ index: 3, field: 'carrier_id', label: 'Transportador', types: [types.datalist()], placeholder: '', title: 'Transportador', store: 'carriers', labels: ['nick'] },
		{ index: 4, field: 'code', label: 'Código', types: [], placeholder: '', title: 'Código da caixa neste transportador' },
		{ index: 5, field: 'length_cm', label: 'Comprimento', types: [types.number(3)], placeholder: '', title: 'Comprimento em cm' },
		{ index: 6, field: 'width_cm', label: 'Largura', types: [types.number(3)], placeholder: '', title: 'Largura em cm' },
		{ index: 7, field: 'depth_cm', label: 'Profundidade', types: [types.number(3)], placeholder: '', title: 'Profundidade em cm' },
		{ index: 8, field: 'volume_cm3', label: 'cm³', types: [types.number(3)], placeholder: '', title: 'Comprimento × largura × profundidade' },
		{ index: 9, field: 'max_weight_kg', label: 'Peso máximo', types: [types.number(3)], placeholder: '', title: 'Peso máximo em kg' },
		{ index: 10, field: 'is_disabled', label: 'Inativo', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Caixa inativa não entra na conferência' },
	];

	const operations = [
		{ hash: '#carrier-box-disable', label: 'Inativar' },
		{ hash: '#carrier-box-enable', label: 'Ativar' },
	];

	router.set('#carrier-box-disable', carrier_boxes_crud.setDisabled.bind(carrier_boxes_crud, true));
	router.set('#carrier-box-enable', carrier_boxes_crud.setDisabled.bind(carrier_boxes_crud, false));

	carrier_boxes_crud.run(
		'carrier_boxes',
		'Caixas',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		[]
	);
};

export default carrier_boxes;
